import PromotionHomeContainer from './PromotionHomeContainer';
export default PromotionHomeContainer;
